import { render } from "./BoardDetailContents.vue?vue&type=template&id=0af1f2d6"
import script from "./BoardDetailContents.vue?vue&type=script&lang=js"
export * from "./BoardDetailContents.vue?vue&type=script&lang=js"
script.render = render

export default script